const {default: logo} = require('./logo.png');
const {default: logoSvg} = require('./logo.svg');
const {default: logoLightSvg} = require('./logo-light.svg');

const config = {
	firebaseConfig: {
		apiKey: 'AIzaSyDqB_E3sKLHAD-Izbg5jPC8YgfS5pfjYdY',
		authDomain: 'commulino-luetzeln.firebaseapp.com',
		databaseURL: 'https://commulino-luetzeln.firebaseio.com',
		projectId: 'commulino-luetzeln',
		storageBucket: 'commulino-luetzeln.appspot.com',
		messagingSenderId: '616095931652',
		appId: '1:616095931652:web:ace8fb716318f8f9174451'
	},
	project: 'luetzeln',
	appName: 'Christliche Seniorenhäuser',
	appStoreUrl: 'https://apps.apple.com/de/app/christliche-seniorenh%C3%A4user/id1505327993',
	playStoreUrl: 'https://play.google.com/store/apps/details?id=de.commulino.luetzeln',
	logo,
	logoSvg,
	logoLightSvg,
}

module.exports = config
